import { render, staticRenderFns } from "./topUseDetails.vue?vue&type=template&id=ff5e7b08&scoped=true"
import script from "./topUseDetails.vue?vue&type=script&lang=js"
export * from "./topUseDetails.vue?vue&type=script&lang=js"
import style0 from "./topUseDetails.vue?vue&type=style&index=0&id=ff5e7b08&prod&lang=scss&scoped=true"
import style1 from "./topUseDetails.vue?vue&type=style&index=1&id=ff5e7b08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5e7b08",
  null
  
)

export default component.exports